import type { LevelKey } from '../types/quiz'

export interface BrevoFormConfig {
  /** URL del atributo action del formulario de Brevo. */
  action: string
  title: string
  /** Parte del título en negrita, tal como viene en el HTML de Brevo. */
  titleStrong?: string
  description: string
  buttonLabel: string
  /** Nombre del atributo de teléfono en Brevo: 'WHATSAPP' en los formularios nuevos. */
  phoneAttribute: 'SMS' | 'WHATSAPP'
  /** Mensaje de éxito propio de cada formulario. */
  successMessage: string
  /** Prefijo telefónico preseleccionado (data-country-code). */
  defaultCountryCode: string
}

/** Un formulario de Brevo por nivel de resultado, conectado a su lista. */
export const brevoForms: Partial<Record<LevelKey, BrevoFormConfig>> = {
  A: {
    action:
      'https://67c7c977.sibforms.com/serve/MUIFANFZYyETm5okituddXmadx7Uo4FuEru2KF4Oqhdn5UG-FDnTfN24FTV4eRG2UTgtyWJU1IpJ40cc-1FKrt6xBftnnehjem1Jl4r4e039hTjGqNMDGeSx0OHl1emARmhSoLvN2ITT9wUfzoVM7aG4tuqtveGsK6cgvZ2aMV3X8kNU6AjO2uwsusPuaGfCk0rd3jbp-TMPoOMPLA==',
    title: 'Tu Resultado Nivel de Culpa.',
    description:
      'Estás cargando con más culpa de la que te corresponde. Déjame tu nombre, email y tu numero para enviarte tu resultado completo y el primer paso para soltarlo.',
    buttonLabel: 'Ver mi resultado completo',
    phoneAttribute: 'WHATSAPP',
    successMessage:
      '¡Listo! Ya casi tienes tu resultado. Revisa tu correo en los próximos segundos (y la carpeta de spam o promociones, por si acaso) ahí te espera tu resultado completo.',
    defaultCountryCode: '+54',
  },
  B: {
    action:
      'https://67c7c977.sibforms.com/serve/MUIFAEc5OP-vGCRvNAYtB384I6XbYac5yoY9HaS5WvHDm8Q_YUnPIwGbN2q6HOXq2HyAYQ4NRpjUBw9TslQ4QCt-I3MVH6UF9RbTeQzV8uY54bE_oaORx8Eftqmq6Vo-cxLiriDTwrrb3lzoA1Qvku9kykbRlp0-J_9Eyrw5Oc-XtadsKEkoloxxFHzfJkR0r-zGI3APK7wEqzkOwA==',
    title: 'Tu Resultado Nivel Apatía.',
    description:
      'Tu mente bajó la intensidad para protegerte, pero eso también te está frenando. Déjame tu nombre, email y tu numero para enviarte tu resultado completo.',
    buttonLabel: 'Ver mi resultado completo',
    phoneAttribute: 'WHATSAPP',
    successMessage:
      '¡Listo! Revisa tu correo ahí te espera tu resultado completo y cómo reactivar tu energía para empezar a sanar de verdad.',
    defaultCountryCode: '+54',
  },
  C: {
    action:
      'https://67c7c977.sibforms.com/serve/MUIFAITAi4lJrqQoUYGJuG8W1T-WDd7u9lw-soxvT_zoU6x-n0hBF4OegJWCmUSuzl2V2mwvR248JxNawd8AYdj2f0e1Xf7imS_7f9gm_mxbg-md7tDdGy3YYs-Wvzs0rwuLOPNeF48_oqUxr82YWmPLTdX93_qoDssmFvKrinjU2W8gJFJDlMDWsy-7C2sONmzQu0-doDjcoZyasw==',
    title: 'Tu Resultado ',
    titleStrong: 'Nivel de Ira/Orgullo.',
    description:
      'Sientes que tienes derecho a estar resentido/a y probablemente lo tienes. Déjame tu nombre, email y tu numero para enviarte tu resultado completo.',
    buttonLabel: 'Ver mi resultado completo',
    phoneAttribute: 'WHATSAPP',
    successMessage:
      '¡Listo! Revisa tu correo ahí te espera tu resultado completo y cómo soltar el orgullo sin que eso signifique que la otra persona "ganó".',
    defaultCountryCode: '+54',
  },
  D: {
    action:
      'https://67c7c977.sibforms.com/serve/MUIFANYpHeyt2xiuyp0JbRn6T5ONPGA3Shjr48mlWrIF6vFVntuLsVcI_BUctypfmhTy3v00HsaKrCuq8qviTdW01JroYiDt9DfhJ-ZjIrF2mS7lrMfOFnJ2Mb_i0nN18wLUQYLVambFe04bF_26sEhAaMipXObfve_p6dz5Cfey7Usgw360Yk0yPCZA9JKiO4JaRBzTkZMjgA0CIQ==',
    title: 'Tu Resultado Nivel de Coraje.',
    description:
      'Ya empezaste el proceso real de sanación. Déjame tu nombre, email y tu numero para enviarte tu resultado completo y cómo consolidar este avance.',
    buttonLabel: 'Ver mi resultado completo',
    phoneAttribute: 'WHATSAPP',
    successMessage:
      '¡Listo! Revisa tu correo ahí te espera tu resultado completo y cómo evitar recaer en niveles anteriores en los días difíciles.',
    defaultCountryCode: '+54',
  },
  E: {
    action:
      'https://67c7c977.sibforms.com/serve/MUIFAGSin__T1jru8X-kAumVj4Zt5e9niII8KikrHUkdbo1cIF9SlUJBkl5CeGnv-fU8FwyDH5yFeR5aAQTATzw2KG8J6iKjWVPsxZgaHVol1cwqnNNZxjKOASUy4LVdjFYxK458q7gfQRB89Lp9xOAeCGdd43HNEV0rS_z2jxF5EuX-zZ_vVuIvr0q9-S3KjYIrZa0C7u52gnqJnw==',
    title: 'Tu Resultado Nivel de Amor/Paz.',
    description:
      'Ya integraste la lección y estás listo/a para amar desde la plenitud. Déjame tu nombre, Email y tu Numero para enviarte tu resultado completo.',
    buttonLabel: 'Ver mi resultado completo',
    phoneAttribute: 'WHATSAPP',
    successMessage:
      '¡Listo! Revisa tu correo ahí te espera tu resultado completo y cómo blindar este nivel en tu próxima relación.',
    defaultCountryCode: '+54',
  },
}
